<!-- #REGION HEADER -->
<header class="aig-header u-size-per-100">
  <div class="aig-header__container u-py-2">
    <div class="p-flexcb u-gap-16">
      <div class="aig-header__block u-gap-8">
        <a class="aig-header__marsh" href="/" id="logo-aig">
          <img
            class="u-size-per-100 a"
            src="./assets/images/logos/marsh.svg"
            alt="logo_marsh"
            loading="lazy"
          />
        </a>
        <a class="aig-header__aig" href="/" id="logo-aig">
          <img
            class="u-size-per-100 a"
            src="./assets/images/logos/logo.svg"
            alt="logo_aig"
            loading="lazy"
          />
        </a>
        <a
          class="aig-header__caixa"
          href="https://www.caixabank.com/es/home_es.html"
          target="_blank"
          id="logo-caixabank"
        >
          <img
            src="./assets/images/logos/lacaixa.svg"
            alt="logo-lacaixa"
            loading="lazy"
            width="100%"
            height="auto"
          />
        </a>
      </div>

      <div class="p-flexcs" *ngIf="visibleBtnSesion">
          @if (authenticated) {
            <nav class="u-me-4">
              <ul class="nav">
                <li>
                  <a class="nav-link" [routerLink]="['/area-cliente']" [routerLinkActive]="['active-link']" [routerLinkActiveOptions]="{exact: true}" (click)="goToClientArea()">
                    Inicio
                  </a>
                </li>
                <li>
                  <a class="nav-link" [routerLink]="['/area-cliente/historial-polizas']" [routerLinkActive]="['active-link']" (click)="goToHistoryPolicy()">
                    Historial de pólizas
                  </a>
                </li>
                <li>
                  <a class="nav-link" [routerLink]="['/area-cliente/gestion-siniestros']" [routerLinkActive]="['active-link']" (click)="goToClaimManagement()">
                    Gestión de siniestros
                  </a>
                </li>
              </ul>
            </nav>
            
            <div class="p-flexcc u-gap-16">
              <button
                class="e-btn--secondary p-flexcc u-gap-8 u-fw-500"
                type="button"
                (click)="LogOut()"
              >
                <p class="aig-header__logout">Cerrar sesión</p>
                <i class="icon-logout u-fs-20"></i>
              </button>
            </div>
          } @else {
            <button
              class="e-btn--secondary p-flexcc u-gap-8 u-fw-500"
              type="button"
              (click)="goToLogin()"
            >
              <i class="icon-user-usuario u-fs-20"></i>
            </button>
          }
      </div>
    </div>
  </div>
</header>
<!-- #ENDREGION -->
